<p-dialog
  appendTo="body"
  header="Discussion of Visits"
  [modal]="true"
  [closable]="false"
  [minY]="70"
  [maximizable]="false"
  [style]="{ width: '1000px' }"
  [(visible)]="isVisible"
>
  <div class="mt-12">
    Based on current information, the timely service lines requested qualify for auto approval for units
    displayed to initiate care. If additional visits to continue care are needed after the approved visits
    are performed, a request can be submitted with updated clinical documentation.
  </div>
  <form [formGroup]="negotiationForm">
    <p-table
      dataKey="authorizationDetailId"
      [value]="adjudication.negotiations"
      [responsive]="true"
    >
      <ng-template pTemplate="header">
        <th>Skill</th>
        <th>HCPC</th>
        <th>Revenue</th>
        <th>Effective<br>From</th>
        <th>Effective<br>To</th>
        <th>Requested<br>Visits</th>
        <th>Approved<br>Visits</th>
        <th>Accept</th>
        <th>Reject</th>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-negotiation
        let-rowIndex="rowIndex"
      >
        <tr>
          <td>{{negotiation.skillCode}}</td>
          <td>{{negotiation.hcpcCode}}</td>
          <td>{{negotiation.revenueCode}}</td>
          <td>{{negotiation.effectiveFromDate | date: 'MM/dd/yyyy'}}</td>
          <td>{{negotiation.effectiveToDate | date: 'MM/dd/yyyy'}}</td>
          <td>{{negotiation.requestedAmount}}</td>
          <td>{{negotiation.skillCapAmount}}</td>
          <td
            class="text-center"
            pEditableColumn
          >
            <ng-container formArrayName="negotiations">
              <ng-container [formGroupName]="rowIndex">
                <div class="flex items-center justify-center">
                  <p-radio-button
                    formControlName="acceptOrReject_{{rowIndex}}"
                    name="acceptOrReject_{{rowIndex}}"
                    [inputId]="'acceptOrReject_' + rowIndex + '_accept'"
                    value="Accept"
                    (onClick)="setLineAcceptOrReject(rowIndex, 'Accept')"
                  />
                  <label [for]="'acceptOrReject_' + rowIndex + '_accept'" class="ml-2">Accept</label>
                </div>
              </ng-container>
            </ng-container>
          </td>
          <td
            class="text-center"
            pEditableColumn
          >
            <ng-container formArrayName="negotiations">
              <ng-container [formGroupName]="rowIndex">
                <div class="flex items-center justify-center">
                  <p-radio-button
                    formControlName="acceptOrReject_{{rowIndex}}"
                    name="acceptOrReject_{{rowIndex}}"
                    [inputId]="'acceptOrReject_' + rowIndex + '_reject'"
                    value="Reject"
                    (onClick)="setLineAcceptOrReject(rowIndex, 'Reject')"
                  />
                  <label [for]="'acceptOrReject_' + rowIndex + '_reject'" class="ml-2">Reject</label>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </form>
  <ng-template #footer>
    <button
      pButton
      label="OK"
      [disabled]="!formValid"
      (click)="handleNegotiationCompleted()"
    ></button>
  </ng-template>
</p-dialog>
